import CalendarEvent from 'umg-ember-backend/components/record-explorer/for/calendar-event';

<template>
  <CalendarEvent @records={{@model}} @recordType='calendar-event' />
</template>
